import { useRestaurants } from "../queries/restaurantQueries";

/**
 * Hook to get the restaurant ID.
 * Returns the ID of La Vida if available, otherwise returns the first restaurant's ID.
 */
export function useRestaurantId(): string | undefined {
  const { data: restaurants } = useRestaurants();

  if (!restaurants || restaurants.length === 0) {
    return undefined;
  }

  // Prefer La Vida if present, otherwise fall back to first restaurant
  const laVida = restaurants.find((r) =>
    r.name.toLowerCase().includes("la vida")
  );
  return (laVida ?? restaurants[0]).id;
}

/**
 * Get the menu URL for a given restaurant ID.
 * If restaurantId is not provided, returns a placeholder that should be replaced.
 */
export function getMenuUrl(restaurantId?: string): string {
  if (!restaurantId) {
    // Return a placeholder - this should be replaced with actual restaurant lookup
    // For now, we'll use "default" as a placeholder
    return "/menu/default";
  }
  return `/menu/${restaurantId}`;
}
